@if ((menuSharedFacade.currentSlideTitle$ | async); as title) {
  <h1 class="print-title"
    [innerHTML]="title | safeHtml">
  </h1>
}
@if ((slideViewerFacade.currentSelectedSlideMedia$ | async); as media) {
  @if (mediaControlService.isDeepzoom(media) || mediaControlService.isImage(media)) {
    <medsurf-image>
    </medsurf-image>
  }
}
@if ((slideViewerFacade.currentSelectedSlidePage$ | async); as slide) {
  @if (slide.header) {
    <h1 class="print-header mt-3"
      >
      {{ slide.header }}
    </h1>
  }
  @if (slide.body) {
    <medsurf-text
      [text]="slide.body"
      [isSlideDescription]="true">
    </medsurf-text>
  }
  @if ((slideViewerFacade.currentSelectedSlideImage$ | async); as image) {
    <medsurf-viewer-interactive-area-list></medsurf-viewer-interactive-area-list>
    <medsurf-viewer-poi-list></medsurf-viewer-poi-list>
  }
  <medsurf-questions></medsurf-questions>
  <medsurf-copyright></medsurf-copyright>
}
